import React from 'react';
import { BuilderWrapperButtonProps } from '@src/pages/workflow/components/BuilderWrapper/type';
import { Button, Popconfirm, Tooltip } from 'antd';

const Footer: React.FC<BuilderWrapperButtonProps> = ({
  hasDeleteButton,
  deleteButtonProps,
  saveButtonProps,
  cancelButtonProps,
  restButtonProps,
  saveAndPreviewButtonProps,
}) => {
  const { usePopconfirm, confirmProps, onClick, children, ...restDeleteButtonProps } =
    deleteButtonProps || {};
  const { hide: isSaveButtonHidden } = saveButtonProps || {};
  const {
    usePopconfirm: useCancelPopconfirm,
    confirmProps: cancelConfirmProps,
    ...restCancelButtonProps
  } = cancelButtonProps || {};

  const {
    isRunning,
    disabled,
    hide: isSaveAndPreviewButtonHidden,
    ...restSaveAndPreviewButtonProps
  } = saveAndPreviewButtonProps || {};

  const renderCancelButton = () => {
    if (useCancelPopconfirm) {
      return (
        <Popconfirm title="" {...cancelConfirmProps}>
          <Button {...restCancelButtonProps}>Cancel</Button>
        </Popconfirm>
      );
    } else {
      return <Button {...cancelButtonProps}>Cancel</Button>;
    }
  };

  // const renderDeleteButton = () => {
  //   const button = (
  //     <Button
  //       type="primary"
  //       danger
  //       ghost
  //       style={{ marginRight: '12px' }}
  //       {...restDeleteButtonProps}
  //     >
  //       Delete
  //     </Button>
  //   );
  //   return deleteButtonProps?.usePopconfirm ? (
  //     <Popconfirm
  //       title="The deleted item cannot be restored. Do you want to continue?"
  //       icon={false}
  //       okText="Delete"
  //       cancelButtonProps={{ type: 'default' }}
  //       okButtonProps={{
  //         danger: true,
  //         type: 'ghost',
  //         style: {
  //           border: '1px solid #d0021b',
  //           color: '#d0021b',
  //         },
  //       }}
  //       onConfirm={(event) => {
  //         onClick?.(event as any);
  //       }}
  //       disabled={restDeleteButtonProps?.disabled}
  //       placement="topLeft"
  //       {...confirmProps}
  //     >
  //       {button}
  //     </Popconfirm>
  //   ) : (
  //     React.cloneElement(children as React.ReactElement, {
  //       onClick: onClick,
  //     })
  //   );
  // };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <div>
        {/*remove the reset button, required by PM*/}
        {/*<Button type="primary" ghost {...restButtonProps}>*/}
        {/*  Reset*/}
        {/*</Button>*/}
        {/*Delete Button only used in dimension builder. dimension builder is not used in new workflow, so remove it.*/}
        {/*{hasDeleteButton && renderDeleteButton()}*/}
        {renderCancelButton()}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}
      >
        {!isSaveButtonHidden && (
          <Button type="primary" ghost {...saveButtonProps}>
            Save
          </Button>
        )}
      </div>
    </div>
  );
};

export default Footer;
